import React, { useEffect, useState } from 'react'
import DashboardTobbar from '../../components/DashboardTobbar/DashboardTobbar'
import Navbar from '../../components/navbar/navbar'
import Premium_content_card from '../../components/premium_content_card/premium_content_card'
import Footer from '../../components/footer/footer'
import MyProfile from '../../components/myprofile/myprofile'
import PendingPaymentCard from '../../components/pending-payment/pendingPaymentCard'
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import axios from "axios";
import { useNavigate } from "react-router-dom";
function PendingPayment() {
    const navigate = useNavigate();
    const [PackExpireDate, setPackExireDate] = useState("");
    const [message, setMessage] = useState("");
    const [Show, setShow] = useState(0);
    useEffect(() => {
        const Token = JSON.parse(localStorage.getItem("kkm_auth"));
        axios.get('https://kovaikongunadumatrimony.com/kkm_backend/public/api/user-payment-status', {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        })
            .then(res => {
                console.log("im here", res);
                if (res.data.status == false) {
                    const rechargeCount = res.data.recharge_count;
                    if (rechargeCount == 1) {
                        setShow(1);
                        setPackExireDate(res.data.last_reacharge);
                        setMessage(res.data.message)
                    }
                }
                if (res.data.status === true) {
                    navigate('/dashboard')
                }
            })
    }, []);
    return (
        <>
            <DashboardTobbar />
            {Show == 1 && (
                <>
                    <h6 className="selectpackage_heading">{message}</h6>
                    <p className='text-center'>Register Date: {PackExpireDate}</p>

                </>
            )}
            {Show == 0 && (
                <>
                    <h2 className="selectpackage_heading">complete your payment</h2>

                </>

            )}

            <PendingPaymentCard />
            <Footer />
        </>
    )
}

export default PendingPayment